import { render, staticRenderFns } from "./tab-pane-account-status.vue?vue&type=template&id=fa9e1e22&scoped=true"
import script from "./tab-pane-account-status.vue?vue&type=script&lang=js"
export * from "./tab-pane-account-status.vue?vue&type=script&lang=js"
import style0 from "./tab-pane-account-status.vue?vue&type=style&index=0&id=fa9e1e22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9e1e22",
  null
  
)

export default component.exports